import script from "./NotesOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesOverview.vue?vue&type=script&setup=true&lang=ts"

import "./NotesOverview.vue?vue&type=style&index=0&id=1c9347e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c9347e1"]])

export default __exports__